import React from 'react';
import { Tag } from '../Tag';

interface BetaTagProps {
  className?: string;
}

export const BetaTag: React.FC<BetaTagProps> = ({ className }) => (
  <Tag size="small" priority="medium" className={className}>
    {'Beta'}
  </Tag>
);
